import { FinanceProductCreate, FinanceProductEdit, FinanceProductList } from './FinanceProducts'

export default {
  list: FinanceProductList,
  create: FinanceProductCreate,
  edit: FinanceProductEdit,
}
